import { render, staticRenderFns } from "./PublicShareAuthSidebar.vue?vue&type=template&id=1085617e&scoped=true"
import script from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js"
export * from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js"
import style0 from "./PublicShareAuthSidebar.vue?vue&type=style&index=0&id=1085617e&prod&lang=css"
import style1 from "./PublicShareAuthSidebar.vue?vue&type=style&index=1&id=1085617e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1085617e",
  null
  
)

export default component.exports